module.exports = __webpack_public_path__ + "static/media/sik.b72fcd36.jpg";